import { Pipette } from "lucide-react";
import { usd } from "../lib/money";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

const calls = (n) => `${n || 1} paid AI call${n === 1 ? "" : "s"}`;
const payerNote = (pays) =>
  pays === "staff"
    ? "It is recorded on this duck's cost ledger as staff spend under your email. It does not use the customer's allowance."
    : "It counts against this duck's maker allowance, like any paid step.";

// Opt-in paid re-read of the approved render's colours (owner accounts + staff only): cost first, once per approved render.
export const RereadColoursOption = ({ state, checked, onChange, disabled }) => {
  if (!state?.allowed) return null;
  return (
    <div data-testid="reread-colours-option" className="rounded-xl border border-dashed border-border bg-background/60 p-3 space-y-1.5">
      <label className="flex items-start gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          data-testid="reread-colours-checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled || !state.available}
          className="mt-0.5 h-4 w-4 accent-[var(--accent)]"
        />
        <span className="min-w-0">
          <span className="font-semibold flex items-center gap-1.5">
            <Pipette className="h-3.5 w-3.5 text-accent" /> Re-read colours from the approved render
          </span>
          <span className="block text-xs text-muted-foreground font-mono2" data-testid="reread-colours-cost">
            about {usd(state.cost_usd)} · {calls(state.calls)} · once per approved render
          </span>
        </span>
      </label>
      {!state.available && state.why && (
        <p data-testid="reread-colours-why" className="text-xs text-muted-foreground">{state.why}</p>
      )}
    </div>
  );
};

export const RereadConfirmDialog = ({ open, state, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent data-testid="reread-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Re-read the colours for about {usd(state?.cost_usd)}?</AlertDialogTitle>
        <AlertDialogDescription data-testid="reread-confirm-text">
          {calls(state?.calls)} read the approved render's colours again (eyes included), then the duck is repainted.{" "}
          {payerNote(state?.pays)} If the re-read fails, the old colours stay and any calls already made are still recorded.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="reread-confirm-cancel">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="reread-confirm-ok" onClick={onConfirm}>Re-read &amp; repaint</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
